import dynamic from 'next/dynamic';
export default dynamic(() =>
	import(/* webpackChunkName:"HeaderOfficeLocation" */ './HeaderOfficeLocation').then((mod) => mod.default)
);
